import { render, staticRenderFns } from "./VIPService.vue?vue&type=template&id=9d3bcebe&scoped=true&"
import script from "./VIPService.vue?vue&type=script&lang=js&"
export * from "./VIPService.vue?vue&type=script&lang=js&"
import style0 from "./VIPService.vue?vue&type=style&index=0&id=9d3bcebe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3bcebe",
  null
  
)

export default component.exports